module.exports = __webpack_public_path__ + "img/timer.2de0f6a8.svg";